module.exports = __webpack_public_path__ + "img/download-apk-badge.56a9ff2c.svg";